import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { env } from 'process';
// const httpOptions = {
//     headers: new HttpHeaders({ 'Content-Type': 'application/json' })
// };

@Injectable({ providedIn: 'root' })

export class FileService {

    fileServiceAPI: string = '';
    orgfileServiceAPI: string = '';
    TENANT_ID: string = '';
    logTnntId: number = null;

    constructor(private api: ApiService,private authSvc: AuthenticationService) {
        this.fileServiceAPI = environment.fileServiceAPI;
        this.orgfileServiceAPI = environment.orgfileServiceAPI;
        this.TENANT_ID = sessionStorage.getItem('currentTenant')
        authSvc.tnntSbjct.subscribe(s => this.logTnntId = s);
    }
    isValidFileName(fileName) {
        const validFileNamePattern = /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9]+)?$/;
        return validFileNamePattern.test(fileName);
      }
    //File API's
    fileupload(data: any): Observable<any> { return this.api.post(`${environment.orgfileServiceAPI}`, data); }
    fileuploadExcel(path:any,data: any): Observable<any> { return this.api.post(`${path}?TENANT_ID=${this.authSvc.tenantId == null ? sessionStorage.getItem('currentTenant') : this.authSvc.tenantId}`, data); }
    fileuploadExcelCamp(path:any,campId:any,data: any): Observable<any> { return this.api.post(`${path}?TENANT_ID=${this.authSvc.tenantId == null ? sessionStorage.getItem('currentTenant') : this.authSvc.tenantId}&camp_id=${campId}`, data); }
    uploadFile(data: any): Observable<any> { return this.api.post(`${this.fileServiceAPI}upload?TENANT_ID=${this.authSvc.tenantId == null ? sessionStorage.getItem('currentTenant') : this.authSvc.tenantId}`, data); }
    uploadExcel(data: any): Observable<any> { return this.api.post(`${environment.loginAPI}lab/lab-result/uploadExcel?TENANT_ID=${this.authSvc.tenantId == null ? sessionStorage.getItem('currentTenant') : this.authSvc.tenantId}`, data); }
    uploadOrgFile(data: any): Observable<any> { return this.api.post(`${environment.loginAPI}${this.orgfileServiceAPI}upload`, data); }
    upldFile(data: any): Observable<any> { return  this.api.post(`${environment.loginAPI}${environment.registrationAPI.replace('jwt/','')}beneficiary/upload?TENANT_ID=${this.authSvc.tenantId == null ? this.TENANT_ID : this.authSvc.tenantId}`, data); }
    // downloadFile(id: number, registrationType: string = 'LAB'): Observable<any> { return this.api.get(`${this.fileServiceAPI}doctor/getdoctorrecordbyid?doctorId=${id}`); }
}
/*
https://vidmedplus.dhanushinfotech.com/file-service/file/upload
request for
==========
{
file :  select File
lab_id:   2,--------->for Update file
id:100,
isActive:  true
screenName:  LAB,PHARMACY,DOCTOR(These are the screenNames need to send either of One)
}

https://vidmedplus.dhanushinfotech.com/file-service/file/download/LAB/21/21_1586695472203_4.pdf
*/